// 複数のスクリーンから使うAPI。
// スクリーン固有のものは liveApi / trendApi / searchApi / detailApi /
// adminApi / contactApi に置く。


// SCREEN_DETAIL / utils/userPreference
export const searchVtuberById = async (id) => {
  const userId = localStorage.getItem("user")
  const response = await fetch(
    `https://daikou-diverse-api.com/api/data_202608/detail/${id}?userId=${userId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  const data = await response.json();

  return data;
};

// SCREEN_TREND / SCREEN_DETAIL
export const searchVideos = async (vtuberId) => {
  const userId = localStorage.getItem("user")
  const response = await fetch(
    `https://daikou-diverse-api.com/api/data_202608/detail/${vtuberId}/videos?userId=${userId}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  const data = await response.json();

  return [data.items ?? [], data.total ?? 0];
};

// GET /vtubers/count
// 登録VTuber数を有効数字2桁で切り捨てた概算値(atLeast)で返す
// NavSearch(全スクリーン共通のヘッダー)から使う
export const getVtuberCount = async () => {
  const response = await fetch(
    `https://daikou-diverse-api.com/api/data_202608/search/count`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
      },
    },
  );

  if (!response.ok) {
    throw new Error(`HTTP error: ${response.status}`);
  }

  const data = await response.json();

  return data.atLeast;
};

// SCREEN_ADMIN / SCREEN_SEARCH(VTuberCard) / SCREEN_DETAIL(VTuberProfile)
export const rejectAttribute = async (vtuberId, attribute) => {
  const response = await fetch(
    `https://daikou-diverse-api.com/api/data_202608/admin/attributes/${vtuberId}/reject`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ attribute }),
    },
  );

  if (!response.ok) {
    const data = await response.json().catch(() => null);
    throw new Error(data?.error ?? "属性の却下に失敗しました");
  }
};

// POST /attributes/:id/remove
// vtubers.attributes(承認済みタグ)から指定した1件を取り除く。candidate_attributesは対象外。
// SCREEN_SEARCH(VTuberCard) / SCREEN_DETAIL(VTuberProfile)
export const removeApprovedAttribute = async (vtuberId, attribute) => {
  const response = await fetch(
    `https://daikou-diverse-api.com/api/data_202608/admin/attributes/${vtuberId}/remove`,
    {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ attribute }),
    },
  );

  if (!response.ok) {
    const data = await response.json().catch(() => null);
    throw new Error(data?.error ?? "属性の削除に失敗しました");
  }
};
